import React from 'react';
import { useLang } from '../contexts/LanguageContext';
import { ui, contact, serviceCategories } from '../data/content';

export default function Footer() {
  const { lang } = useLang();

  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <footer data-testid="main-footer"
      style={{
        background: '#050c1f',
        borderTop: '1px solid rgba(255,215,0,0.15)',
        padding: '56px 20px 24px',
        position: 'relative', overflow: 'hidden',
      }}>

      {/* Top golden ray */}
      <div style={{ position: 'absolute', top: 0, left: '50%', transform: 'translateX(-50%)', width: '300px', height: '1px',
        background: 'linear-gradient(to right, transparent, rgba(255,215,0,0.5), transparent)' }} />

      <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
        {/* ── Social Media Banner ── */}
        <div style={{
          background: 'rgba(19,32,74,0.6)', border: '1px solid rgba(255,215,0,0.15)',
          borderRadius: '16px', padding: '28px 24px', marginBottom: '40px', textAlign: 'center',
        }}>
          <p style={{ fontFamily: '"Cinzel Decorative", serif', fontSize: '11px', color: '#FF9933', letterSpacing: '4px', textTransform: 'uppercase', marginBottom: '20px' }}>
            ✦ {lang === 'hi' ? 'हमसे जुड़ें — सोशल मीडिया पर' : 'Connect With Us on Social Media'} ✦
          </p>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '14px', flexWrap: 'wrap' }}>
            {[
              { icon: 'fa-brands fa-instagram', color: '#FF4500', label: 'Instagram', sublabel: lang === 'hi' ? 'इंस्टाग्राम' : 'Instagram', href: '#', id: 'instagram' },
              { icon: 'fa-brands fa-facebook-f', color: '#FFD700', label: 'Facebook', sublabel: lang === 'hi' ? 'फेसबुक' : 'Facebook', href: '#', id: 'facebook' },
              { icon: 'fa-brands fa-youtube', color: '#D2042D', label: 'YouTube', sublabel: lang === 'hi' ? 'यूट्यूब' : 'YouTube', href: '#', id: 'youtube' },
              { icon: 'fa-brands fa-whatsapp', color: '#50C878', label: 'WhatsApp', sublabel: lang === 'hi' ? 'WhatsApp चैनल' : 'WhatsApp Channel', href: `https://wa.me/${contact.whatsapp}`, id: 'whatsapp' },
              { icon: 'fa-brands fa-x-twitter', color: '#FFF3B0', label: 'X (Twitter)', sublabel: lang === 'hi' ? 'ट्विटर / X' : 'Twitter / X', href: '#', id: 'twitter' },
              { icon: 'fa-brands fa-telegram', color: '#FF9933', label: 'Telegram', sublabel: lang === 'hi' ? 'टेलीग्राम' : 'Telegram', href: '#', id: 'telegram' },
            ].map(s => (
              <a key={s.id} href={s.href} target="_blank" rel="noopener noreferrer"
                data-testid={`footer-social-${s.id}`}
                aria-label={s.label}
                style={{
                  display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px',
                  textDecoration: 'none', padding: '16px 20px', borderRadius: '14px',
                  background: `${s.color}10`, border: `1px solid ${s.color}30`,
                  minWidth: '90px', cursor: 'pointer',
                  transition: 'background 0.25s, box-shadow 0.25s, transform 0.2s',
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.background = `${s.color}20`;
                  e.currentTarget.style.boxShadow = `0 0 20px ${s.color}40`;
                  e.currentTarget.style.transform = 'translateY(-4px)';
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.background = `${s.color}10`;
                  e.currentTarget.style.boxShadow = 'none';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}>
                <div style={{
                  width: '50px', height: '50px', borderRadius: '14px',
                  background: `${s.color}18`, border: `1px solid ${s.color}50`,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  boxShadow: `0 0 10px ${s.color}30`,
                }}>
                  <i className={s.icon} style={{ fontSize: '22px', color: s.color, filter: `drop-shadow(0 0 5px ${s.color})` }} />
                </div>
                <span style={{ fontSize: '12px', color: s.color, fontFamily: 'Khand, sans-serif', fontWeight: 600, lineHeight: 1.2 }}>
                  {s.sublabel}
                </span>
              </a>
            ))}
          </div>
          <p style={{ fontSize: '11px', color: 'rgba(255,243,176,0.3)', fontFamily: 'Khand, sans-serif', marginTop: '14px', marginBottom: 0 }}>
            {lang === 'hi' ? 'जल्द ही सभी प्लेटफ़ॉर्म पर लाइव होंगे' : 'Coming soon on all platforms'}
          </p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '40px', marginBottom: '48px' }}>

          {/* Brand column */}
          <div>
            <div className="hindi divine-glow-text" style={{ fontFamily: '"Yatra One", cursive', fontSize: '22px', color: '#FFD700', marginBottom: '6px' }}>
              श्री रणजीत सर्विसेस
            </div>
            <div style={{ fontFamily: '"Cinzel Decorative", serif', fontSize: '8px', color: '#FF9933', letterSpacing: '2px', marginBottom: '14px' }}>
              SHRI RANJEET SERVICES
            </div>
            <p className="hindi-body" style={{ fontSize: '13px', color: 'rgba(255,243,176,0.6)', lineHeight: 1.7, fontFamily: 'Khand, sans-serif', marginBottom: '16px' }}>
              {ui.footer.tagline[lang]}
            </p>
          </div>

          {/* Quick links */}
          <div>
            <h4 style={{ fontFamily: '"Cinzel Decorative", serif', fontSize: '11px', color: '#FFD700', letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '16px' }}>
              {ui.footer.quickLinks[lang]}
            </h4>
            {['home', 'services', 'about', 'contact'].map(k => (
              <button key={k} onClick={() => scrollTo(k === 'services' ? 'services' : k === 'about' ? 'about' : k === 'contact' ? 'contact' : 'home')}
                style={{
                  display: 'block', background: 'none', border: 'none', cursor: 'pointer',
                  color: 'rgba(255,243,176,0.65)', fontFamily: 'Khand, sans-serif', fontSize: '14px',
                  padding: '5px 0', textAlign: 'left',
                }}
                onMouseEnter={e => e.target.style.color = '#FFD700'}
                onMouseLeave={e => e.target.style.color = 'rgba(255,243,176,0.65)'}>
                <i className="fa-solid fa-angle-right" style={{ fontSize: '10px', marginRight: '8px', color: '#FF9933' }} />
                {ui.nav[k]?.[lang] || k}
              </button>
            ))}
          </div>

          {/* Services preview */}
          <div>
            <h4 style={{ fontFamily: '"Cinzel Decorative", serif', fontSize: '11px', color: '#FFD700', letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '16px' }}>
              {ui.footer.ourServices[lang]}
            </h4>
            {serviceCategories.map(cat => (
              <button key={cat.id}
                onClick={() => document.getElementById(`service-${cat.id}`)?.scrollIntoView({ behavior: 'smooth' })}
                style={{
                  display: 'block', background: 'none', border: 'none', cursor: 'pointer',
                  color: 'rgba(255,243,176,0.65)', fontFamily: 'Khand, sans-serif', fontSize: '13px',
                  padding: '4px 0', textAlign: 'left',
                }}
                onMouseEnter={e => e.target.style.color = cat.color}
                onMouseLeave={e => e.target.style.color = 'rgba(255,243,176,0.65)'}>
                <i className={`fa-solid ${cat.iconClass}`} style={{ fontSize: '10px', marginRight: '8px', color: cat.color }} />
                {lang === 'hi' ? cat.titleHi : cat.titleEn}
              </button>
            ))}
          </div>

          {/* Contact + Legal */}
          <div>
            <h4 style={{ fontFamily: '"Cinzel Decorative", serif', fontSize: '11px', color: '#FFD700', letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '16px' }}>
              {lang === 'hi' ? 'संपर्क जानकारी' : 'Contact Info'}
            </h4>
            <div style={{ marginBottom: '12px' }}>
              <a href={`tel:${contact.phone}`} style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#FF9933', textDecoration: 'none', fontFamily: 'Khand, sans-serif', fontSize: '14px', marginBottom: '8px' }}>
                <i className="fa-solid fa-phone" style={{ fontSize: '12px' }} />{contact.phone}
              </a>
              <a href={`mailto:${contact.email}`} style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#50C878', textDecoration: 'none', fontFamily: 'Khand, sans-serif', fontSize: '12px', marginBottom: '8px' }}>
                <i className="fa-solid fa-envelope" style={{ fontSize: '11px' }} />{contact.email}
              </a>
              <p style={{ color: 'rgba(255,243,176,0.55)', fontSize: '12px', fontFamily: 'Khand, sans-serif', lineHeight: 1.6 }}>
                <i className="fa-solid fa-location-dot" style={{ color: '#FFD700', marginRight: '6px', fontSize: '11px' }} />
                {lang === 'hi' ? contact.addressHi : contact.addressEn}
              </p>
            </div>
            <div style={{ marginTop: '16px', borderTop: '1px solid rgba(255,215,0,0.1)', paddingTop: '14px' }}>
              <h4 style={{ fontFamily: '"Cinzel Decorative", serif', fontSize: '10px', color: '#FFD700', letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '10px' }}>
                {ui.footer.legal[lang]}
              </h4>
              {[
                { label: ui.footer.privacy[lang], href: '#' },
                { label: ui.footer.terms[lang], href: '#' },
              ].map(l => (
                <a key={l.label} href={l.href}
                  style={{ display: 'block', color: 'rgba(255,243,176,0.5)', fontFamily: 'Khand, sans-serif', fontSize: '12px', padding: '3px 0', textDecoration: 'none' }}
                  onMouseEnter={e => e.target.style.color = '#FFD700'}
                  onMouseLeave={e => e.target.style.color = 'rgba(255,243,176,0.5)'}>
                  {l.label}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div style={{ borderTop: '1px solid rgba(255,215,0,0.1)', paddingTop: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '10px' }}>
          <p style={{ color: 'rgba(255,243,176,0.4)', fontSize: '12px', fontFamily: 'Khand, sans-serif', margin: 0 }}>
            © {new Date().getFullYear()} श्री रणजीत सर्विसेस. {ui.footer.copy[lang]}.
          </p>
          <p style={{ color: 'rgba(255,153,0,0.5)', fontSize: '11px', fontFamily: 'Rajdhani, sans-serif', margin: 0 }}>
            🚩 जय श्री राम 🚩
          </p>
          <p style={{ color: 'rgba(255,243,176,0.3)', fontSize: '11px', fontFamily: 'Khand, sans-serif', margin: 0 }}>
            Indore, Madhya Pradesh
          </p>
        </div>
      </div>

      {/* Floating WhatsApp button */}
      <a href={`https://wa.me/${contact.whatsapp}`} target="_blank" rel="noopener noreferrer"
        data-testid="floating-whatsapp"
        className="wa-float"
        style={{
          width: '56px', height: '56px', borderRadius: '50%', background: 'linear-gradient(135deg, #1a7a3f, #50C878)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          textDecoration: 'none', boxShadow: '0 4px 20px rgba(80,200,120,0.5)',
        }}>
        <i className="fa-brands fa-whatsapp" style={{ fontSize: '26px', color: '#FFF3B0' }} />
      </a>
    </footer>
  );
}
